var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddYouTube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 -0.5 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.168 19.003a4.183 4.183 0 0 0 4.332-4.017V9.02a4.183 4.183 0 0 0-4.332-4.017H6.832A4.183 4.183 0 0 0 2.5 9.02v5.966a4.183 4.183 0 0 0 4.332 4.017h11.336Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.008 9.178 3.161 2.148a.667.667 0 0 1 0 1.152l-3.161 2.35c-.6.407-1.508.06-1.508-.576v-4.5c0-.633.909-.981 1.508-.574Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddYouTube);
export default __webpack_public_path__ + "static/media/addYouTube.1fb889e6e7e0e33cf22a9479d96cf7fd.svg";
export { ForwardRef as ReactComponent };